export default "__VITE_ASSET__9830a25d__"